import { GroupedCartItem } from "src/common/types/cart";
import { BaseResponse } from "src/common/types/response/BasePaginationResponse";
import { ImageMapper } from "assets/images";

const processPaginatedItems = <T>(
  res: BaseResponse<T>,
  response: BaseResponse<T>
): BaseResponse<T> => {
  type Template = T & { _id };
  const uniqueIds = new Set(
    (response?.payload || [])?.map((item: Template) => item._id)
  );
  const filteredPayload = (res?.payload || [])?.filter(
    (item: Template) => !uniqueIds.has(item._id)
  );
  const payload = {
    ...res,
    payload: [...(response?.payload || []), ...(filteredPayload || [])],
  };

  return payload;
};

const groupItemBasedOnStoreId = (payload) => {
  const groupedPayload = {};
  payload.forEach((item) => {
    const storeId = item.store._id;
    if (!groupedPayload[storeId]) {
      groupedPayload[storeId] = {
        items: [],
        name: item.store.name,
      };
    }
    groupedPayload[storeId].items.push(item);
  });

  return groupedPayload;
};

const groupItemWithStoreName = <T>(
  items: {
    [key: string]: GroupedCartItem;
  },
  section?: boolean
): {
  dataToRender: T[];
  totalItems: number;
} => {
  const dataToRender = [];
  let totalItems = 0;
  for (const [key, it] of Object.entries(items)) {
    if (section) {
      const data = [];
      it.items.forEach((it) => {
        totalItems += 1;
        data.push(it);
      });
      dataToRender.push({
        header: it.name,
        data,
        footer: it.items
          .reduce((acc, cur) => {
            const totalItemPrice = cur.price * (cur.quantity || 1);
            return acc + totalItemPrice;
          }, 0)
          .toFixed(2),
      });
    } else {
      dataToRender.push({ header: true, name: it.name, _id: key });
      it.items.forEach((it) => {
        totalItems += 1;
        dataToRender.push(it);
      });
      dataToRender.push({
        footer: true,
        _id: `${key}-${it.items[0]._id}`,
        price: it.items
          .reduce((acc, cur) => {
            const totalItemPrice = cur.price * (cur.quantity || 1);
            return acc + totalItemPrice;
          }, 0)
          .toFixed(2),
      });
    }
  }
  return { dataToRender, totalItems };
};

const getDeliveryTypeIcon = (type: number) => {
  switch (type) {
    case 1:
      return ImageMapper.Instant;
    case 2:
      return ImageMapper.Scheduled;
    default:
      return ImageMapper.InStore;
  }
};

export {
  processPaginatedItems,
  groupItemBasedOnStoreId,
  groupItemWithStoreName,
  getDeliveryTypeIcon,
};
